module.exports = __webpack_public_path__ + "static/media/B.TECH.IIITL.23.05.19-converted-1.63184dbc.pdf";